import httpClientB2B from "../../config/b2b";

const createCustomer = (data) =>
  new Promise((resolve, reject) => {
    httpClientB2B({
      method: 'POST',
      url: 'api/v1/create/test/user',
      data: data,

    },)
      .then(resp => {
        resolve(resp.data);
      })
      .catch(error => {
        reject(error);
      });
  });

const scoreByUploadStatement = (data, uuid) =>
  new Promise((resolve, reject) => {
    httpClientB2B({
      method: 'POST',
      url: 'api/v1/b2b/score/uploadStatement',
      data: data, headers: {
        "Content-Type": "multipart/form-data",
        "x-reference-id": uuid
      }
    })
      .then(resp => {
        resolve(resp.data);
      })
      .catch(error => {
        reject(error.response.data);
      });
  });

const multipleUploadStatement = (data, uuid) =>
  new Promise((resolve, reject) => {
    httpClientB2B({
      method: 'POST',
      url: 'api/v1/b2b/multiple/uploadStatements',
      data: data, headers: {
        "Content-Type": "multipart/form-data",
        "x-reference-id": uuid
      }
    })
      .then(resp => {
        resolve(resp.data);
      })
      .catch(error => {
        reject(error.response.data);
      });
  });


const creditReportService = (data, uuid) =>
  new Promise((resolve, reject) => {
    httpClientB2B({
      method: 'POST',
      url: 'api/v1/b2b/credit/report/upload',
      data: data, headers: {
        "Content-Type": "multipart/form-data",
        "x-reference-id": uuid
      }
    })
      .then(resp => {
        resolve(resp.data);
      })
      .catch(error => {
        reject(error);
      });
  });


const documentUploadedList = (data, uuid) =>
  new Promise((resolve, reject) => {
    httpClientB2B({
      method: 'POST',
      url: 'api/v1/b2b/lending/document/get/uploaded/list',
      data: data,
      headers: { "x-reference-id": uuid }
    }).then(resp => {
      resolve(resp.data);
    }).catch(error => {
      reject(error);
    });
  });


const uploadAddExcelAPI = (data) =>
  new Promise((resolve, reject) => {
    httpClientB2B({
      method: 'POST',
      url: 'api/v1/b2b/upload/excel/file',
      data: data,
      headers: {
        "Content-Type": "multipart/form-data",
      }

    }).then(resp => {
      resolve(resp.data);
    }).catch(error => {
      reject(error);
    });
  });

const downloadLendingDocumentAPI = (data, uuid) =>
  new Promise((resolve, reject) => {
    httpClientB2B({
      method: 'POST',
      responseType: 'blob',
      url: 'api/v1/b2b/lending/document/download',
      data: data,
      headers: { "x-reference-id": uuid }
    }).then(resp => {
      resolve(resp.data);
    }).catch(error => {
      reject(error);
    });
  });

const reportDownload = (data, uuid, demoClientToken) =>
  new Promise((resolve, reject) => {
    const headers = {
      "x-reference-id": uuid,
      ...(demoClientToken && { Authorization: `Bearer ${demoClientToken}` }),
    };
    httpClientB2B({
      method: 'POST',
      responseType: 'blob',
      url: 'api/v1/b2b/boost/report/get',
      data: data,
      headers: headers,

    }).then(resp => {
      resolve(resp.data);
    }).catch(error => {
      reject(error);
    });
  });

const downloadExcelReport = (data, uuid, demoClientToken) =>
  new Promise((resolve, reject) => {
    const headers = {
      "x-reference-id": uuid,
      ...(demoClientToken && { Authorization: `Bearer ${demoClientToken}` }),
    };
    httpClientB2B({
      method: 'POST',
      responseType: 'blob',
      url: 'api/v1/b2b/boost/report/get/excel',
      data: data,
      headers: headers
    }).then(resp => {
      resolve(resp.data);
    }).catch(error => {
      reject(error);
    });
  });

const downloadExcelAnalysisReport = (data, uuid) =>
  new Promise((resolve, reject) => {
    httpClientB2B({
      method: 'POST',
      responseType: 'blob',
      url: 'api/v1/b2b/excel/analysis/download',
      data: data,
      headers: { "x-reference-id": uuid }
    }).then(resp => {
      resolve(resp.data);
    }).catch(error => {
      reject(error);
    });
  });

const getBankList = (data) =>
  new Promise((resolve, reject) => {
    httpClientB2B({
      method: 'POST',
      url: '/api/v1/b2b/get/banks',
      data: data
    }).then(resp => {
      resolve(resp);
    }).catch(error => {
      reject(error.response.data);
    });
  });

const getInvoiceData = (data) =>
  new Promise((resolve, reject) => {
    httpClientB2B({
      method: 'POST',
      url: 'api/v1/b2b/billing/invoice/get',
      data: data
    }).then(resp => {
      resolve(resp);
    }).catch(error => {
      reject(error);
    });
  });

const filterInvoiceData = (data) =>
  new Promise((resolve, reject) => {
    httpClientB2B({
      method: 'POST',
      url: 'api/v1/b2b/billing/invoice/filter',
      data: data
    }).then(resp => {
      resolve(resp);
    }).catch(error => {
      reject(error);
    });
  });

const downloadInvoice = (data) =>
  new Promise((resolve, reject) => {
    httpClientB2B({
      method: 'POST',
      responseType: 'blob',
      url: 'api/v1/b2b/invoice/download',
      data: data
    }).then(resp => {
      resolve(resp);
    }).catch(error => {
      reject(error);
    });
  });
const getClientConfiguration = () =>
  new Promise((resolve, reject) => {
    httpClientB2B({
      method: 'GET',
      url: '/api/v1/b2b/sdk/get/client/configuration',
    }).then(resp => {
      resolve(resp.data);
    }).catch(error => {
      reject(error);
    });
  });

const getTokenApiBoostAI = (data, demoClientToken) =>
  new Promise((resolve, reject) => {
    const headers = {
      ...(demoClientToken && { Authorization: `Bearer ${demoClientToken}` }),
    };
    httpClientB2B({
      method: 'POST', data: data,
      url: '/api/v1/b2b/user/token/get',
      headers: headers
    }).then(resp => {
      resolve(resp.data);
    }).catch(error => {
      reject(error);
    });
  });

const gstUploadApi = (data) =>
  new Promise((resolve, reject) => {
    httpClientB2B({
      method: 'POST', data: data,
      url: '/api/v1/b2b/gst/upload',
    }).then(resp => {
      resolve(resp.data);
    }).catch(error => {
      reject(error);
    });
  });

const gstExcelDownloadApi = (data) =>
  new Promise((resolve, reject) => {
    httpClientB2B({
      responseType: 'blob',
      method: 'POST', data: data,
      url: '/api/v1/b2b/gst/download/excel',
    }).then(resp => {
      resolve(resp.data);
    }).catch(error => {
      reject(error);
    });
  });

const sendCopilateApi = (data) =>
  new Promise((resolve, reject) => {
    httpClientB2B({
      method: 'POST', data: data,
      url: '/api/v1/b2b/lending/get/link',
    }).then(resp => {
      resolve(resp.data);
    }).catch(error => {
      reject(error);
    });
  });

const getAllTemplateApi = (bureau) =>
  new Promise((resolve, reject) => {
    httpClientB2B({
      method: 'GET',
      url: 'api/v1/b2b/lending/get/all/templates',
    })
      .then(resp => {
        resolve(resp.data);
      })
      .catch(error => {
        reject(error);
      });
  });


const creditReportDataBID = (bureau,) => (param, demoClientToken) =>

  new Promise((resolve, reject) => {
    const headers = {
      ...(demoClientToken && { Authorization: `Bearer ${demoClientToken}` }),
    };
    httpClientB2B({
      method: 'POST',
      headers: headers,
      data: param,
      url: 'api/v1/b2b/credit/report/get/analysis',
      // url: 'api/v1/b2b/credit/report/get' + (bureau !== '' ? '?bureauName=' + bureau : ''),
    })
      .then(resp => {
        resolve(resp.data);
      })
      .catch(error => {
        reject(error);
      });
  });

const boostScoreReportBID = (param, demoClientToken) =>
  new Promise((resolve, reject) => {
    const headers = {
      ...(demoClientToken && { Authorization: `Bearer ${demoClientToken}` }),
    };
    httpClientB2B({
      method: 'POST',
      data: param,
      headers: headers,
      url: 'api/v1/b2b/multiple/score/get',
    })
      .then(resp => {
        resolve(resp.data);
      })
      .catch(error => {
        reject(error);
      });
  });
const getDemoTestUserList = () =>
  new Promise((resolve, reject) => {
    httpClientB2B({
      method: 'GET',
      url: `api/v1/get/demo/users`
    })
      .then(resp => {
        resolve(resp.data);
      })
      .catch(error => {
        reject(error);
      });
  });

const getUserProfileEachUser = (reqData) =>
  new Promise((resolve, reject) => {
    httpClientB2B({
      method: 'POST',
      data: reqData,
      url: `api/v1/b2b/get/user/profile`
    })
      .then(resp => {
        resolve(resp.data);
      })
      .catch(error => {
        reject(error);
      });
  });

const uploadSupportDocument = (reqData) =>
  new Promise((resolve, reject) => {
    httpClientB2B({
      method: 'POST',
      url: 'api/v1/b2b/lending/document/upload',
      data: reqData, headers: {
        "Content-Type": "multipart/form-data",
      }
    })
      .then(resp => {
        resolve(resp.data);
      })
      .catch(error => {
        reject(error);
      });
  });


  const getScrubMetadata = () =>
   new Promise((resolve, reject) => {
    httpClientB2B({
      method: 'GET',
      url: `api/v1/b2b/scrub/data/search/metadata`
    })
      .then(resp => {
        resolve(resp.data);
      })
      .catch(error => {
        reject(error);
      });
  });


  const postScrubMetadata = (scrubData) =>
    new Promise((resolve, reject) => {
      httpClientB2B({
        method: 'POST',
        url: 'api/v1/b2b/scrub/data/search',
        data: scrubData
      })
        .then(resp => {
          resolve(resp.data);
        })
        .catch(error => {
          reject(error);
        });
  });


   const viewScrubData = (scrubData) =>
    new Promise((resolve, reject) => {
      httpClientB2B({
        method: 'POST',
        url: 'api/v1/b2b/scrub/data/detail',
        data: scrubData
      })
        .then(resp => {
          resolve(resp.data);
        })
        .catch(error => {
          reject(error);
        });
  });

   const downloadScrubExcel = (scrubData) =>
    new Promise((resolve, reject) => {
      httpClientB2B({
        method: 'POST',
        url: 'api/v1/b2b/scrub/data/search/excel',
        data: scrubData,
        responseType: 'blob'
      }).then(resp => {
          resolve(resp.data);
      }).catch(error => {
          reject(error);
      });
  });

  const getShortUrl = (longUrl) =>
    new Promise((resolve, reject) => {
      httpClientB2B({
        method: 'POST',
        url: 'api/v1/b2b/url-shortener/shorten',
        data: longUrl
      }).then(resp => {
          resolve(resp.data);
      }).catch(error => {
          reject(error);
      });
  });


export {
  createCustomer,
  scoreByUploadStatement,
  creditReportService,
  reportDownload,
  downloadExcelReport,
  getBankList,
  getInvoiceData,
  filterInvoiceData,
  downloadInvoice,
  multipleUploadStatement,
  getClientConfiguration,
  downloadExcelAnalysisReport,
  getTokenApiBoostAI,
  gstUploadApi,
  gstExcelDownloadApi,
  downloadLendingDocumentAPI,
  documentUploadedList,
  sendCopilateApi,
  getAllTemplateApi,
  creditReportDataBID,
  boostScoreReportBID,
  getDemoTestUserList,
  uploadAddExcelAPI,
  getUserProfileEachUser,
  uploadSupportDocument,
  getScrubMetadata,
  postScrubMetadata,
  viewScrubData,
  downloadScrubExcel,
  getShortUrl
}